 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		61: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		61: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"styles","5":"component---src-pages-404-js","6":"component---src-pages-about-js","7":"component---src-pages-bios-js","8":"component---src-pages-consignment-belle-etoile-js","9":"component---src-pages-consignment-bracelet-js","10":"component---src-pages-consignment-colored-js","11":"component---src-pages-consignment-diamond-js","12":"component---src-pages-consignment-earring-js","13":"component---src-pages-consignment-engagement-js","14":"component---src-pages-consignment-fashion-js","15":"component---src-pages-consignment-filter-js","16":"component---src-pages-consignment-index-js","17":"component---src-pages-consignment-kit-heath-js","18":"component---src-pages-consignment-lika-behar-js","19":"component---src-pages-consignment-necklace-js","20":"component---src-pages-consignment-page-js","21":"component---src-pages-consignment-pendant-js","22":"component---src-pages-consignment-ring-js","23":"component---src-pages-consignment-silver-js","24":"component---src-pages-consignment-simon-g-js","25":"component---src-pages-consignment-wedding-js","26":"component---src-pages-contact-js","27":"component---src-pages-custom-js","28":"component---src-pages-dery-js","29":"component---src-pages-diamond-gemstones-js","30":"component---src-pages-diamonds-js","31":"component---src-pages-engagement-js","32":"component---src-pages-events-index-js","33":"component---src-pages-gemstones-js","34":"component---src-pages-index-js","35":"component---src-pages-jewelry-js","36":"component---src-pages-newsletters-index-js","37":"component---src-pages-privacy-policy-js","38":"component---src-pages-products-belle-etoile-js","39":"component---src-pages-products-bracelet-js","40":"component---src-pages-products-colored-js","41":"component---src-pages-products-diamond-js","42":"component---src-pages-products-earring-js","43":"component---src-pages-products-engagement-js","44":"component---src-pages-products-fashion-js","45":"component---src-pages-products-index-js","46":"component---src-pages-products-kit-heath-js","47":"component---src-pages-products-lika-behar-js","48":"component---src-pages-products-necklace-js","49":"component---src-pages-products-pendant-js","50":"component---src-pages-products-ring-js","51":"component---src-pages-products-silver-js","52":"component---src-pages-products-simon-g-js","53":"component---src-pages-products-wedding-js","54":"component---src-pages-search-js","55":"component---src-pages-services-js","56":"component---src-pages-stories-index-js","57":"component---src-pages-test-js","58":"component---src-pages-thanks-js","59":"component---src-templates-event-template-js","60":"component---src-templates-product-template-js"}[chunkId]||chunkId) + "-" + {"0":"35575fe8e357d5f5c7e9","1":"7b6cf0522e41e2cf1822","2":"bdc79e78bf6d209e348a","3":"c80931326c65d439e62a","5":"5ab2325bebeff7ed4138","6":"0126aa1724e719bee53f","7":"25525137b5e84e97f23c","8":"84c115a1907bde52f0f7","9":"0cbd637f1b798f634c1d","10":"cd097573e467d1a711eb","11":"4079043f042da971a5c8","12":"b8f5853d7b24caf7f195","13":"38e5156d0041f6208422","14":"dcf6ed3d35b8aea7fad4","15":"dc3c7573e90f679210cf","16":"e9299ba61feea65340a2","17":"8be23e8c92cd2061c5cb","18":"64d54b541e1ac0469071","19":"a1e7c6be57ef66b2ba69","20":"da969d3f5d9de1196abc","21":"d02bda8e649b802e7871","22":"ac63def586f27403c203","23":"05a4d71d11c7113b4d4e","24":"a2743560fcf9b5e0b25a","25":"4ea310780ad57480ceaa","26":"88e94c6b5381ca1f2367","27":"3f9f453caa6568187995","28":"bed132907c72d08ab42f","29":"27119b79f4c10d7055f5","30":"dd781878c14c7f9f501e","31":"ef92acad80485cb3014e","32":"2824fe2fdd083b0818e4","33":"a0fccc8600239b1faa3c","34":"7d2c887cdca6519116c5","35":"a09887527cdbed66ff87","36":"6c1ca6aab43e480ab581","37":"37a1d2a8ef65e73193c8","38":"52ab7def70fe1b1902ea","39":"0d5e6732bdc230fdc434","40":"a2bafa11c21bc5233090","41":"bab4587b0a7115a4118f","42":"1e266ced094c4534dd0e","43":"ed956bf1da359783da73","44":"28450f75f37ec840f208","45":"0a42cfcbe9f876912d8b","46":"cc97b6cb651ecfec6d3d","47":"114da334d7837a252217","48":"755d8260875bae845fee","49":"04750feb2b712f66b9da","50":"4ea923bbed82118f38cd","51":"bb768a93101d73d547f8","52":"b9b633823af754c56368","53":"7326000a9c187775c626","54":"3c1fd0e0b4a7fa6d44f8","55":"69eeb3835154c07562e8","56":"57cf46f1d1b13e598dc0","57":"e489886543fe462c132c","58":"0786db6d05cfeabc7d67","59":"a61e9dfd464cb91081a1","60":"9c3a1811e338aad43302","62":"240421846a753f613848"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"1":"styles","5":"component---src-pages-404-js","6":"component---src-pages-about-js","7":"component---src-pages-bios-js","8":"component---src-pages-consignment-belle-etoile-js","9":"component---src-pages-consignment-bracelet-js","10":"component---src-pages-consignment-colored-js","11":"component---src-pages-consignment-diamond-js","12":"component---src-pages-consignment-earring-js","13":"component---src-pages-consignment-engagement-js","14":"component---src-pages-consignment-fashion-js","15":"component---src-pages-consignment-filter-js","16":"component---src-pages-consignment-index-js","17":"component---src-pages-consignment-kit-heath-js","18":"component---src-pages-consignment-lika-behar-js","19":"component---src-pages-consignment-necklace-js","20":"component---src-pages-consignment-page-js","21":"component---src-pages-consignment-pendant-js","22":"component---src-pages-consignment-ring-js","23":"component---src-pages-consignment-silver-js","24":"component---src-pages-consignment-simon-g-js","25":"component---src-pages-consignment-wedding-js","26":"component---src-pages-contact-js","27":"component---src-pages-custom-js","28":"component---src-pages-dery-js","29":"component---src-pages-diamond-gemstones-js","30":"component---src-pages-diamonds-js","31":"component---src-pages-engagement-js","32":"component---src-pages-events-index-js","33":"component---src-pages-gemstones-js","34":"component---src-pages-index-js","35":"component---src-pages-jewelry-js","36":"component---src-pages-newsletters-index-js","37":"component---src-pages-privacy-policy-js","38":"component---src-pages-products-belle-etoile-js","39":"component---src-pages-products-bracelet-js","40":"component---src-pages-products-colored-js","41":"component---src-pages-products-diamond-js","42":"component---src-pages-products-earring-js","43":"component---src-pages-products-engagement-js","44":"component---src-pages-products-fashion-js","45":"component---src-pages-products-index-js","46":"component---src-pages-products-kit-heath-js","47":"component---src-pages-products-lika-behar-js","48":"component---src-pages-products-necklace-js","49":"component---src-pages-products-pendant-js","50":"component---src-pages-products-ring-js","51":"component---src-pages-products-silver-js","52":"component---src-pages-products-simon-g-js","53":"component---src-pages-products-wedding-js","54":"component---src-pages-search-js","55":"component---src-pages-services-js","56":"component---src-pages-stories-index-js","57":"component---src-pages-test-js","58":"component---src-pages-thanks-js","59":"component---src-templates-event-template-js","60":"component---src-templates-product-template-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"db98243f5727f9f9d741","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
